"use strict";
/*
 * Created on 11 02 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AbstractEntityFilter_1 = require("../../core/model/overview/AbstractEntityFilter");
/**
 * {@link CompetitorProduct competitor product filter}.
 *
 * @author Radek Beran
 */


var CompetitorProductFilter =
/*#__PURE__*/
function (_AbstractEntityFilter) {
  _inherits(CompetitorProductFilter, _AbstractEntityFilter);

  function CompetitorProductFilter(textForSearch, ignored, competitorIds) {
    var _this;

    _classCallCheck(this, CompetitorProductFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CompetitorProductFilter).call(this));
    _this.textForSearch = textForSearch;
    _this.ignored = ignored;
    _this.competitorIds = competitorIds;
    return _this;
  }

  return CompetitorProductFilter;
}(AbstractEntityFilter_1.AbstractEntityFilter);

exports.CompetitorProductFilter = CompetitorProductFilter;
CompetitorProductFilter.EMPTY = new CompetitorProductFilter();